/**
 * This is the main entry point of the Javascript.
 * It initializes the necessary components.
 */

// import AOS from "aos";
import Sliders from "./components/Sliders";
import Faq from "./components/Faq";

document.addEventListener("DOMContentLoaded", () => {
	// AOS.init();
	Sliders();
    Faq();

	const toggleItems = document.querySelectorAll(".applications__wrapper-items-left-item");
	const rightItems = document.querySelectorAll(".applications__wrapper-items-right-item");
    const header = document.querySelector('.header');
    const offerItems = document.querySelectorAll('.offer__wrapper-items-item');
    const allNotEmptyLinks      = document.querySelectorAll('a[href^="#"]');
    const burgerWrapper = document.querySelector(".burger-menu");
	const burgerClose = document.querySelector(".burger-menu__close");
	const burgerLines = document.querySelector(".burger-js");
    const systemRightItems = document.querySelectorAll(".system-options__wrapper-content-right-items-item");
    const systemLeftImages = document.querySelectorAll(".system-options__wrapper-content-left-image-item");
    const formSend = document.querySelector('.wpcf7-form');
    
    if(formSend) {
        document.addEventListener('wpcf7mailsent', function (event) {
            window.location.href = '/dziekujemy/';
        }, false);
    }

    systemRightItems.forEach(item => {
        item.addEventListener("mouseenter", function () {
            const id = this.dataset.item;

            systemRightItems.forEach(i => i.classList.remove("active"));
            systemLeftImages.forEach(img => img.classList.remove("active"));

            this.classList.add("active");

            const leftImage = document.querySelector(`.system-options__wrapper-content-left-image-item[data-item="${id}"]`);
            if (leftImage) leftImage.classList.add("active");
        });
    });

    if (burgerLines) {
		burgerLines.addEventListener("click", function () {
			if (burgerWrapper) {
                burgerLines.classList.add('hidden');
				burgerWrapper.classList.add("active");
			}
		});
	}

	if (burgerClose) {
		burgerClose.addEventListener("click", function () {
			if (burgerWrapper) {
                burgerLines.classList.remove('hidden');
				burgerWrapper.classList.remove("active");
			}
		});
	}

	if (burgerWrapper) {
		burgerWrapper.addEventListener("click", function (e) {
			if (e.target === burgerWrapper) {
                burgerLines.classList.remove('hidden');
				burgerWrapper.classList.remove("active");
			}
		});
	}

    // Scroll smoothly to element with ID
    if (allNotEmptyLinks) {
        allNotEmptyLinks.forEach(anchor => {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();

                const targetId = this.getAttribute('href');
                if (targetId && targetId.startsWith('#') && targetId.length > 1) {
                    const targetElement = document.querySelector(targetId);
                    console.log(targetElement)
                    if (targetElement) {
                        const yOffset = -50; // 100px shift
                        const yPosition = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;

                        window.scrollTo({
                            top: yPosition,
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });
    }

    if(offerItems.length > 0) {
        offerItems.forEach((item) => {
            item.addEventListener("click", () => {
                if(!item.classList.contains('disabled')) {
                    item.classList.toggle('active');
                }
            });
        });
    } 

    function checkSticky() {
        if (window.scrollY > 100) {
            header.classList.add('sticky');
        } else {
            header.classList.remove('sticky');
        }
    }

    checkSticky();
    window.addEventListener('scroll', checkSticky);

	if (toggleItems.length && rightItems.length) {
		toggleItems.forEach((item) => {
			const box = item.querySelector(".applications__wrapper-items-left-item-box");

			item.addEventListener("click", () => {
				const index = item.dataset.item;

				rightItems.forEach((r) => r.classList.remove("active"));
				const match = document.querySelector(
					`.applications__wrapper-items-right-item[data-item="${index}"]`
				);
				if (match) match.classList.add("active");

				toggleItems.forEach((el) => {
					if (el !== item) {
						el.classList.remove("active");
						el.querySelector(
							".applications__wrapper-items-left-item-box"
						).style.maxHeight = "0px";
					}
				});

				if (!item.classList.contains("active")) {
					item.classList.add("active");
					box.style.maxHeight = box.scrollHeight + "px";
				} 
			});
		});

		window.addEventListener("load", () => {
			const first = toggleItems[0];
			const firstBox = first.querySelector(
				".applications__wrapper-items-left-item-box"
			);
			const firstRight = rightItems[0];

			first.classList.add("active");
			firstBox.style.maxHeight = firstBox.scrollHeight + "px";
			firstRight.classList.add("active");
		});
	}
});
